import styled from 'styled-components';

export const CanvasContainer = styled.div``;
export const ChartTotalSpan = styled.span`
  float: right;
  padding-right: 5px;
  font-size: 12px;
  cursor: default;
  text-shadow: 0px 0px 5px #ffffff;
  text-align: right;
`;
export const ChartZeroResultSpan = styled.span`
  clear: both;
  float: right;
  padding-right: 5px;
  font-size: 12px;
  cursor: default;
  text-shadow: 0px 0px 5px #ffffff;
`;
export const BoldSpan = styled.span`
  font-weight: bold;
`;
export const Note = styled.p`
  color: gray;
  font-weight: normal;
  font-style: italic;
  font-size: 14px;
  display: block;
  padding: 40px;
  text-align: center;
`;

export const ZeroPointNote = styled.p`
  margin-bottom: 0px;
`;
